// extracted by mini-css-extract-plugin
export default {"container":"KDdeLelaBDA1efme6OlR"};